import { BANK_ACC_TYPE_MAP, INV_ACC_PRODUCTS_KEY_MAP, KYC_STATUS_KEY_MAP } from "../../constants/myAccount";
import { get, isEmpty, repeat } from "lodash-es";
import { splitMobileNumber } from "../common/functions";
import { AUTH_TYPE_KEY_MAP } from "../../constants/SecondaryContactVerification/constants";

export const getProcessedAccountData = (response) => {
  if (isEmpty(response)) return {};
  // store.dispatch(setAccountData(response));

  const banksListMap = {
    "equity": getEquityBanksFromKyc(response.kyc),
    "mf": getMfBanksFromKyc(response.kyc)
  };

  return {
    ...response,
    banksListMap,
  };
};

export const getPropFromAccountData = (accountData, propName) => {
  return get(accountData, propName, undefined);
};

export const getProductKycMapForLanding = ({
  isTradingEnabled,
  kycStatus,
  kyc
}) => {
  
  const { STOCKS, MF, FNO, CURRENCY } = INV_ACC_PRODUCTS_KEY_MAP;
  let statusMap = {
    [MF]: KYC_STATUS_KEY_MAP.INIT,
    [STOCKS]: KYC_STATUS_KEY_MAP.INIT,
    [FNO]: KYC_STATUS_KEY_MAP.INIT,
	  [CURRENCY]: KYC_STATUS_KEY_MAP.INIT,
  };

  if (kycStatus === 'rejected') {
    statusMap[STOCKS] = KYC_STATUS_KEY_MAP.REJECTED;
    if (kyc.application_status_v2 !== 'complete') {
      statusMap[MF] = KYC_STATUS_KEY_MAP.REJECTED;
    }
  }
  
  const isKycInprogres = ["submitted", "verifying_trading_account"].includes(kycStatus);
  if (isKycInprogres) {
    statusMap[MF] = KYC_STATUS_KEY_MAP.IN_PROGRESS;
    if (isTradingEnabled) {
      statusMap[STOCKS] = KYC_STATUS_KEY_MAP.IN_PROGRESS;
    }
  }

  if (kyc.kyc_allow_investment_status === 'INVESTMENT_ALLOWED') {
    statusMap[MF] = KYC_STATUS_KEY_MAP.COMPLETE;
  }

  if (isTradingEnabled) {
    const fnoSegmentStatus = get(kyc, "broking_account_segment_status.fno", "");
    const currencySegmentStatus = get(kyc, "broking_account_segment_status.currency", "");
    if (kyc.equity_investment_ready) {
      statusMap[STOCKS] = KYC_STATUS_KEY_MAP.COMPLETE;
    }
    statusMap[CURRENCY] = currencySegmentStatus;
    statusMap[FNO] = fnoSegmentStatus;

    if (kyc.kyc_product_type !== 'equity') {
      statusMap[FNO] = KYC_STATUS_KEY_MAP.INACTIVE;
      statusMap[CURRENCY] = KYC_STATUS_KEY_MAP.INACTIVE;
      statusMap[STOCKS] = KYC_STATUS_KEY_MAP.INIT;
    }
  }

  return statusMap;
};

export const isSegmentRedirectionEnabled = (kyc = {}) => {
  const fnoSegmentStatus = get(kyc, "broking_account_segment_status.fno", "");
  const currencySegmentStatus = get(kyc, "broking_account_segment_status.currency", "");
  const kycInitAndRejectedStatus = [KYC_STATUS_KEY_MAP.INIT, KYC_STATUS_KEY_MAP.REJECTED];
  const isFnoSegmentInitOrRejected = kycInitAndRejectedStatus.includes(fnoSegmentStatus);
  const isCurrencySegmentInitOrRejected = kycInitAndRejectedStatus.includes(currencySegmentStatus);
  const isFnoAndCurrencyInitOrRejected = isFnoSegmentInitOrRejected && isCurrencySegmentInitOrRejected;
  return isFnoAndCurrencyInitOrRejected;
};

export const getFreedomPlanStatus = (freedomPlanData) => {
  let { subscription_status: planStatus } = freedomPlanData;
  if (freedomPlanData.renewal_cta) {
    planStatus = 'RENEWAL';
  }

  return planStatus;
};

export const getUserDetails = ({
  kyc = {},
  user = {}
}) => { 
  let userDetailsObj = {
    name: "",
    countryCode: "",
    mobileNumber: "",
    email: "",
    isEmailVerified: true,
    isMobileVerified: true,
    pan: get(kyc, "pan.meta_data.pan_number", ""),
    taxStatus: get(kyc, 'identification.meta_data.tax_status', ''),
  };

  const contactDetails = get(kyc, "identification.meta_data", "");

  if (!isEmpty(contactDetails)) {
    const { countryCode, number } = splitMobileNumber(contactDetails.mobile_number);
    const formattedMobileNumber = `${countryCode} ${number}`;
    
    userDetailsObj = Object.assign(userDetailsObj, {
      email: contactDetails.email,
      mobileNumber: number,
      countryCode,
      formattedMobileNumber
    });

    const hasMobile = !isEmpty(contactDetails.mobile_number);
    const hasEmail = !isEmpty(contactDetails.email);

    if (hasMobile) {
      userDetailsObj.isMobileVerified = contactDetails.mobile_number_verified;
    } 
    
    if (hasEmail) {
      userDetailsObj.isEmailVerified = contactDetails.email_verified;
    }
    
    userDetailsObj.dataAvaliable = hasMobile && hasEmail;
    userDetailsObj.hasValidName = user.name !== contactDetails.mobile_number;
    userDetailsObj.name = (
      userDetailsObj.hasValidName
        ? user.name
        : userDetailsObj.formattedMobileNumber
    );
  }

  return userDetailsObj;
};

export const getTradingAccDetailsForUser = (kyc = {}) => {
  return {
    ucc: get(kyc, 'ucc', ''),
    boId: get(kyc, 'boid', ''),
    dpId: get(kyc, 'dpid', ''),
    dematActive: get(kyc, 'equity_investment_ready', ''),
    depositoryName: get(kyc, 'depository_name', ''),
    depositoryParticipant: get(kyc, 'depository_participant', '')
  };
};

export const getMfBanksFromKyc = (kyc) => {
  let banks = [];
  banks.push({ ...kyc.bank.meta_data, isPrimary: true });
  banks = banks.concat(kyc.additional_approved_banks || []);
  return banks;
};

export const getEquityBanksFromKyc = (kyc) => {
  const eqBank = kyc.equity_primary_bank;
  if (kyc.equity_enabled && !isEmpty(eqBank)) {
    return [{ ...eqBank, isPrimary: true }];
  }
  return [];
};

export const obscureBankAccNumber = (accNum, startingDigitCount, endingDigitCount) => {
  // TODO: Create generic function for this, can be reused in other usecases as well
  /*
    @params:
      startingDigitCount => integer value for number of digits to display at the start of the string (leading digits)
      endingDigitCount => integer value for number of digits to display at the end of the string (trailing digits)
  */
  const digitsToObscure = accNum.length - (startingDigitCount + endingDigitCount);
  const leadingDigits = accNum.slice(0, startingDigitCount);
  const trailingDigits = accNum.slice(-endingDigitCount);
  const obscuredDigits = repeat('*', digitsToObscure);

  return `${leadingDigits}${obscuredDigits}${trailingDigits}`;
};

export const getBankDataToShow = (bank = {}) => {
  if (isEmpty(bank)) return {};

  return {
    name: bank.bank_name,
    accountNumber: obscureBankAccNumber(bank.account_number, 3, 4),
    accountType: bank.account_type,
    friendlyAccountType: BANK_ACC_TYPE_MAP[bank.account_type],
    ifscCode: bank.ifsc_code,
    branch: get(bank, 'ifsc_details.branch', ""),
    bankStatus: bank.bank_status,
    isPrimary: bank.isPrimary,
    bankIcon: bank.ifsc_image || bank.bank_image,
    bankId: bank.bank_id
  }
}